import { getEnv } from '../envWrapper'

const env = getEnv()
export const buildAbsoluteUrl = (path: string) => {
	if (path.indexOf('http') === 0) return path
	return `${env.root_domain}${path}`
}
